{
  "00945c89f76b547f": "Qualification",
  "084589b75f7b2594": "Past, unfilled",
  "0cbbed3d4fb3b62d": "Origin and destination addresses don't match. The backend will reject the migration unless the addresses are compatible.",
  "19766ed6ccb2f4a3": "Cancel",
  "1af379f2d2ceaa59": "Confirm migration",
  "234c7002b7c8b66f": "Migrate shifts",
  "34a078687bb02ed2": "The migration was not applied. Try again and run a new preview.",
  "3a60e59aa097fe17": "Effective ending (optional)",
  "417a6b7e1904940a": "Pending verification",
  "44379762f7964194": "Starts soon",
  "46701bfc2e78c6e7": "Total migratable",
  "47c2df10559485d2": "Preview migration",
  "4a49935a4ea295b9": "Origin workplace",
  "4bd00ad4ed1bf62d": ", starting",
  "4f7838402f37674e": "Verified",
  "511ed0936645a3a8": "Migration failed",
  "57393f549b1117cb": "Total ignored",
  "57a0b86121d762e9": "Migration completed successfully.",
  "59b75a09ad8728b6": "Shifts migrated",
  "6031ee797185af1e": "Start typing workplace name...",
  "62f9a7361a1252e3": "Back to parameters",
  "663ea1bfffe5038f": "to",
  "76900f1bfd16c8d4": "Back",
  "7d9eb7acb13e2462": "Close",
  "80ea6bf00677e9ab": "Qualification: {{qualification}}",
  "87c06b34aacdedef": "Migrating shifts from",
  "910e12c594caf689": "Effective starting",
  "95c31eb9f2200e41": "Destination workplace",
  "9c6725dc269a48ce": "through",
  "9d8979e11fdead7a": "name,userId,fullAddress",
  "9facfbe860f996cb": "All shifts within the window are eligible to be migrated.",
  "a242d79c57459c69": "Limit the migration to a single qualification, or migrate every qualification.",
  "a903eee3da327410": "Migration complete",
  "c9b3c38247f744e1": "Total",
  "cc2111dd92b635db": "Searching workplaces...",
  "da50017b4af59e26": "Any qualification",
  "e52e45d02310f868": "Unverified shifts cannot be migrated unless they start more than 4 hours in the future.",
  "e87ced5e089eba2b": "ID: {{id}}",
  "ed077f3d8125d60d": "Open",
  "efb1b9fb7d251ac7": "Address unavailable",
  "f15ae52605d8cb6e": "Qualification: Any",
  "f7476d9ec6213488": "Shifts to migrate",
  "fd1331d7a6cd0309": "Booked",
  "ffc3898a1161a769": "Shifts that will be ignored"
}
